import { render, staticRenderFns } from "./CreateScheduleLoyaltyDiscount.vue?vue&type=template&id=3e9126ed"
import script from "./CreateScheduleLoyaltyDiscount.vue?vue&type=script&lang=js"
export * from "./CreateScheduleLoyaltyDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports